var infiniteScroll = function(url,addons,container,total) {

    function addContent() {
        var row_number = $('#row_number');
        if(row_number.length === 0) {
            $(container).append('<input type="hidden" id="row_number" value="10">');
        }
        var numberOfRow = row_number.val();
        if (numberOfRow > total){
            return false;
        } else{
            if($('#if-loading').length === 0) {
                $(container).append('<div id="if-loading" class="my-4 text-center"><span style="font-size: 60px;" class="fas icon-spinner icon-spin color-color"></span></div>');
            }
            row_number.val(Number(numberOfRow)+10);
            $.ajax({
                type: 'post',
                url: url,
                data: {
                    getresult : numberOfRow,
                    Addons : addons
                },
                success: function (response) {
                    $(container).append(response);
                    $('#if-loading').remove();
                    initLazyLoadImage('.lazy');
                }
            });
        }
    }

    if  ($(window).scrollTop() + 600 > $(document).height() - $(window).height()){
        addContent();
    }

};
